import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import React, { useState } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    panel: {
      padding: 24,
      backgroundColor: theme.palette.background.paper,
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
    },
    description: { 
      marginBottom: 16 
    }
  })
);

interface Props {
  customTags: any;
  onWorkflowCustomTagsChange: (customTags) => void;
}

function WorkflowCustomTagsEditor(props: Props) {
  const { customTags, onWorkflowCustomTagsChange } = props;
  const [tagString, setTagString] = useState(customTags.join(', '));

  const classes = useStyles({});

  const onTagStringChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTagString(event.target.value);
  };

  const onBlur = () => {
    onWorkflowCustomTagsChange(tagString.split(',').map(tag => tag.trim()).filter(tag => tag !== ''));
  };

  return (
    <div className={classes.panel}>
      <Typography variant="caption" display="block" className={classes.description}>
        List of tags to apply to decks upon successful workflow execution
      </Typography>
      <TextField
        placeholder="Comma separated list of tags"
        value={tagString}
        fullWidth
        onChange={onTagStringChange}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          onBlur: onBlur
        }}
      />
    </div>);
};

export default WorkflowCustomTagsEditor;
